import React, { useState, useEffect } from "react";
import axios from "axios";
import { HiPlus, HiPencil, HiTrash } from "react-icons/hi";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as bootstrap from "bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Tagandlabels() {
  const [tags, setTags] = useState([]);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [search, setSearch] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);

  // Base URL for API
  const API_BASE_URL = "http://localhost:5890";

  useEffect(() => {
    fetchTags();
  }, []);

  const fetchTags = async () => {
    setIsLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${API_BASE_URL}/Tagsandlabels`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setTags(res.data);
    } catch (err) {
      console.error("Error fetching tags:", err);
      toast.error("Failed to load tags and labels.");
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setName("");
    setEditId(null);
  };

  const handleSave = async () => {
    if (!name.trim()) {
      toast.warning("Please enter a tag or label name.");
      return;
    }

    setIsSaving(true);
    const token = sessionStorage.getItem("token");

    try {
      if (editId) {
        // Update existing tag
        await axios.put(
          `${API_BASE_URL}/Tagsandlabels/${editId}`,
          { name },
          { 
            headers: { 
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            } 
          }
        );
        toast.success("Tag updated successfully!");
      } else {
        // Create new tag
        await axios.post(
          `${API_BASE_URL}/Tagsandlabels`,
          { name },
          { 
            headers: { 
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            } 
          }
        );
        toast.success("Tag added successfully!");
      }

      // Close modal and refresh data
      document.getElementById("closeModalBtn").click();
      fetchTags();
      resetForm();
    } catch (err) {
      console.error("Error saving tag:", err);
      toast.error(err.response?.data?.error || "Failed to save tag. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  const openEditModal = (tag) => {
    setEditId(tag.id || tag._id);
    setName(tag.name);
    new bootstrap.Modal(document.getElementById("Tagandlabel")).show();
  };

  const filteredTags = tags.filter((tag) =>
    tag.name.toLowerCase().includes(search.toLowerCase())
  );

  const confirmDelete = (id) => {
    setDeleteId(id);
    new bootstrap.Modal(document.getElementById("deleteConfirmModal")).show();
  };

  const handleConfirmDelete = async () => {
    try {
      const token = sessionStorage.getItem("token");
      await axios.delete(`${API_BASE_URL}/Tagsandlabels/${deleteId}`, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });
      toast.success("Tag deleted successfully!");
      fetchTags();
    } catch (err) {
      console.error("Error deleting tag:", err);
      toast.error(err.response?.data?.error || "Failed to delete tag. Please try again.");
    } finally {
      const modal = bootstrap.Modal.getInstance(
        document.getElementById("deleteConfirmModal")
      );
      modal.hide();
      setDeleteId(null);
    }
  };

  return (
    <div className="container my-4">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="bg-white p-4 shadow rounded-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="fw-bold m-0">Tags and Labels</h3>
          <button
            className="btn btn-success d-flex align-items-center gap-2"
            data-bs-toggle="modal"
            data-bs-target="#Tagandlabel"
            onClick={resetForm}
          >
            <HiPlus /> Add Tag / Label
          </button>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              placeholder="Search tag or label..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="table-responsive">
          {isLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <table className="table table-striped table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th width="50">#</th>
                  <th>Name</th>
                  <th width="150">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredTags.length > 0 ? (
                  filteredTags.map((tag, index) => (
                    <tr key={tag.id || tag._id}>
                      <td>{index + 1}</td>
                      <td>{tag.name}</td>
                      <td>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => openEditModal(tag)}
                            title="Edit"
                          >
                            <HiPencil />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => confirmDelete(tag.id || tag._id)}
                            title="Delete"
                          >
                            <HiTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-muted py-4 fst-italic">
                      {search ? "No matching tags found." : "No tags or labels found."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Add/Edit Modal */}
      <div
        className="modal fade"
        id="Tagandlabel"
        tabIndex="-1"
        aria-labelledby="TagandlabelLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4 shadow">
            <div className="modal-header bg-success text-white rounded-top-4">
              <h5 className="modal-title" id="TagandlabelLabel">
                {editId ? "Edit Tag / Label" : "Add Tag / Label"}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeModalBtn"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label fw-semibold">Tag / Label Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter tag or label name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSave()}
                />
                <div className="form-text">
                  Enter a descriptive name for your tag or label.
                </div>
              </div>
            </div>
            <div className="modal-footer bg-light rounded-bottom-4">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                disabled={isSaving}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSave}
                disabled={isSaving}
              >
                {isSaving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {editId ? "Updating..." : "Adding..."}
                  </>
                ) : editId ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div
        className="modal fade"
        id="deleteConfirmModal"
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4 shadow">
            <div className="modal-header bg-danger text-white rounded-top-4">
              <h5 className="modal-title" id="deleteConfirmModalLabel">
                Confirm Deletion
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p className="mb-0">
                Are you sure you want to delete this tag/label? This action cannot be undone.
              </p>
            </div>
            <div className="modal-footer bg-light rounded-bottom-4">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleConfirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}